import { render } from "./Opportunities.vue?vue&type=template&id=8ecfbdb2"
import script from "./Opportunities.vue?vue&type=script&lang=js"
export * from "./Opportunities.vue?vue&type=script&lang=js"
script.render = render

export default script